import { useEffect } from 'react';

/**
 * Hook to handle ESC key press
 * @param onEscape - Callback function to execute when ESC is pressed
 * @param isActive - Whether the hook should be active (default: true)
 */
export const useEscapeKey = (onEscape: () => void, isActive: boolean = true) => {
  useEffect(() => {
    if (!isActive) return;

    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onEscape();
      }
    };

    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [onEscape, isActive]);
};

